import './App.css';
import {BrowserRouter, Route, Switch} from 'react-router-dom';

import gsap from "gsap";
import React, {useEffect} from 'react';
import {ScrollTrigger} from "gsap/ScrollTrigger";
import LanguageProvider from "./Utilities/LanguageContext";
import VideoPlayer from "./Components/VideoPlayer";
import {logEvent,initAmplitude} from "./Utilities/AmplitudeService";
import {withOrientationChange} from "react-device-detect";
import HomePortrait from "./Components/Portrait/homePortrait";
import Services from "./Components/Services/Services";
import Home from "./Components/home";
import Contact from "./Components/contact";
import {isPortrait} from "./Utilities/utils";
import smoothscroll from 'smoothscroll-polyfill';
import PServices from "./Components/Portrait/pServices";
import WhitePaper from "./Components/white-paper/WhitePaper";
import WhitePaper2 from "./Components/white-paper2/WhitePaper2";
import WhitePaper3 from "./Components/white-paper3/WhitePaper3";
import WhitePapersLanding from "./Components/whitepapers-landing/WhitePapersLanding";


const App = props => {
//  let [lastW, lastH] = useState(0);

    smoothscroll.polyfill();
    gsap.registerPlugin(ScrollTrigger);

    gsap.config({
        autoSleep: 60,
        force3D: false,
    });
    /*
        ScrollTrigger.defaults({
            toggleActions: "restart complete resume reverse",
    //        scroller: '.scene-container'
        });
    */
    window.scroll.bind(this)

    useEffect(() => {

    });

    initAmplitude();

    window.addEventListener("orientationchange", function (event) {
        if (!window.location.href.includes('manifest'))
            window.location.reload();
    });

    window.onbeforeunload = function () {
        logEvent('leave_page')
    }

    return (<LanguageProvider>
            <BrowserRouter>
                <Switch>
                    <Route exact path="/contact" render={(props) => <Contact {...props}/>}/>
                    <Route exact path="/manifest" render={(props) => <VideoPlayer {...props}/>}/>
                    <Route exact path="/services/iga"
                           render={(props) => <Services selectedIndex={0} {...props}/>}/>
                    <Route exact path="/services/consulting"
                           render={(props) => <Services selectedIndex={1} {...props}/>}/>
                    <Route exact path="/services/gaming"
                           render={(props) => <Services selectedIndex={2} {...props}/>}/>
                    <Route exact path="/services/esports"
                           render={(props) => <Services selectedIndex={3} {...props}/>}/>
                    <Route exact path="/whitepapers"
                           render={(props) => <WhitePapersLanding {...props}/>}/>
                    <Route exact path="/myths"
                           render={(props) => <WhitePaper {...props}/>}/>
                    <Route exact path="/who-are-we"
                           render={(props) => <WhitePaper2 {...props}/>}/>
                    <Route exact path="/big-events"
                           render={(props) => <WhitePaper3 {...props}/>}/>
                    {(isPortrait()) ? <>
                        <Route exact path="/" render={(props) => <HomePortrait {...props} />}/>
                        <Route exact path="/services"
                               render={(props) => <PServices {...props}/>}/>
                    </> : <>
                        <Route exact path="/" render={(props) => <Home {...props} />}/>
                        <Route exact path="/services" render={(props) => <Services {...props}/>}/>
                    </>}
                </Switch>
            </BrowserRouter>
        </LanguageProvider>
    );
}

export default withOrientationChange(App);
